const Button = ({
  title,
  color = 'blue',
  onClick,
  children,
}: {
  title?: string
  color?: string
  onClick?: () => void
  children?: string
}) => {
  const colorClass =
    color === 'blue'
      ? 'text-white bg-blue-700 hover:bg-blue-800 hover:text-white'
      : 'text-black bg-bg-slate-200'

  return (
    <button
      className={`${colorClass} font-medium rounded-lg text-sm px-3 py-2 mr-1 mb-2 focus:outline-none`}
      onClick={onClick}
    >
      {title ? title : children ? children : 'Click me'}
    </button>
  )
}

export default Button
